// content entity/model — 여러 feature(carStory·report·modoocar)가 공유하는
// 마이클 콘텐츠 도메인 타입·상수. entity는 shared만 import 한다.

/** 마이클 콘텐츠 메뉴 (CAR / DRIVE / NOW) */
export const MYCLE_CONTENT_MENU = {
  CAR: 'CAR',
  DRIVE: 'DRIVE',
  NOW: 'NOW',
} as const

export type TMycleContentMenu =
  (typeof MYCLE_CONTENT_MENU)[keyof typeof MYCLE_CONTENT_MENU]

/** 시리즈 콘텐츠 코드 (관리의 정석 = care, 슬기로운 초보 생활 = beginner, 정비사 이야기 = mechanic) */
export const MYCLE_CONTENT_SERIES_CODE = {
  CARE: 'care',
  BEGINNER: 'beginner',
  MECHANIC: 'mechanic',
} as const

export type TMycleContentSeriesCode =
  (typeof MYCLE_CONTENT_SERIES_CODE)[keyof typeof MYCLE_CONTENT_SERIES_CODE]

/** 마이클 콘텐츠 상세 응답 */
export interface IMycleContentDetailResponse {
  serverId: number
  menu: TMycleContentMenu
  title: string
  thumbnailUrl: string
  contentHtml: string
  likeCount: number
  /** 내가 좋아요한 여부 */
  liked: boolean
  kakaoShareThumbUrl?: string | null
  kakaoShareTitle?: string | null
  kakaoShareDescription?: string | null
  ctaLabel?: string | null
  ctaUrl?: string | null
}
